import request from '@/utils/request'

// 订单管理
// 查询需方订单列表
export function orderQuery(data) {
  return request({
    url: '/mall/mallmanage/demandOrder/query',
    method: 'post',
    data
  })
}
// 订单详情
export function orderDetail(params) {
  return request({
    url: '/mall/mallmanage/demandOrder/orderDetail',
    method: 'post',
    params
  })
}
// 评价订单
export function appraiseOrder(data) {
  return request({
    url: '/mall/mallmanage/demandOrder/appraiseOrder',
    method: 'post',
    data
  })
}
// 取消订单
export function cancelOrder(data) {
  return request({
    url: '/mall/mallmanage/demandOrder/cancelOrder',
    method: 'post',
    data
  })
}
// 确认交易
export function confirmOrder(data) {
  return request({
    url: '/mall/mallmanage/demandOrder/confirmOrder',
    method: 'post',
    data
  })
}
// 确认收货
export function revedOrder(params) {
  return request({
    url: '/mall/mallmanage/demandOrder/revedOrder',
    method: 'post',
    params
  })
}
// 修改商品简码
export function updateOrderStcokCode(params) {
  return request({
    url: '/mall/mallmanage/demandOrder/updateOrderStcokCode',
    method: 'post',
    params
  })
}
// 查询收货地址和账期额度
export function queryReceivingAddr() {
  return request({
    url: '/mall/mallmanage/demandOrder/queryReceivingAddr',
    method: 'post'
  })
}
// 申请退货
export function refundOrder(data) {
  return request({
    url: '/mall/mallmanage/demandOrder/refundOrder',
    method: 'post',
    data
  })
}
// 查询打印模板
export function selectPrintTemplate(params) {
  return request({
    url: '/mall/PrintTemplate/selectPrintTemplate',
    method: 'get',
    params
  })
}
// 保存打印模板
export function addPrintTemplate(data) {
  return request({
    url: '/mall/PrintTemplate/addPrintTemplate',
    method: 'post',
    data
  })
}
